import React, { forwardRef, PropsWithChildren, ReactNode } from 'react';
import css from './index.module.scss';

interface MonthScrollerProps {
  scrollOffset: number;
  dragging: boolean;
  setDragging: (dragging: boolean) => void;
  onDrag: (clientY: number) => void;
  children: ReactNode;
}

const MonthScroller = forwardRef<HTMLDivElement, PropsWithChildren<MonthScrollerProps>>(
  ({ scrollOffset, dragging, setDragging, onDrag, children }, forwardedRef) => (
    <div
      data-component="MonthScroller"
      ref={forwardedRef}
      className={css.scroller}
      style={{
        transform: `translateY(${-scrollOffset}px)`,
      }}
      onPointerDownCapture={evt => {
        (evt.target as HTMLDivElement).setPointerCapture(evt.pointerId);
        // prevent mouse down from triggering text selection
        evt.preventDefault();
        setDragging(true);
        onDrag(evt.clientY);
      }}
      onPointerMoveCapture={evt => {
        if (!dragging) return;
        onDrag(evt.clientY);
      }}
      onPointerUpCapture={() => {
        setDragging(false);
      }}
      role="none"
    >
      {children}
    </div>
  ),
);
MonthScroller.displayName = 'MonthScroller';

const MemoizedMonthScroller = React.memo(MonthScroller);

export { MemoizedMonthScroller as MonthScroller };
